import { useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { BodyS } from 'atoms/typography';

import { SettingsSection } from '../SettingsSection';
import { BlockedUsersDialog } from './BlockedUsersDialog';

const StyledButtonBase = styled(ButtonBase)`
  color: var(--c-link);
  text-decoration: underline;
`;
const messages = defineMessages({
  title: {
    id: 'Settings.blockedUsers.title',
    defaultMessage: 'Blocked Managers',
  },
  description: {
    id: 'Settings.blockedUsers.description',
    defaultMessage: 'Manage the list of the managers you’ve blocked',
  },
  cta: {
    id: 'Settings.blockedUsers.cta',
    defaultMessage: 'Manage',
  },
});

export const BlockedUsers = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  return (
    <SettingsSection {...messages}>
      <div>
        <StyledButtonBase onClick={() => setOpenDialog(true)}>
          <BodyS bold>
            <FormattedMessage {...messages.cta} />
          </BodyS>
        </StyledButtonBase>
      </div>

      {!!openDialog && (
        <BlockedUsersDialog onClose={() => setOpenDialog(false)} />
      )}
    </SettingsSection>
  );
};
